import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('form.editors.time.TimeEditor', {
    clearField: 'Clear field',
    selectTimePlaceholder: 'Select time',
    selectDatePlaceholder: 'Select date',
    ok: 'OK',
});
